import { LevelsInfoDetails } from '../../../../types/register';
import { brlFormatter } from '../../../../utils';
import './levels.scss';

import React from "react";

interface LevelsInfoProps {
    data: LevelsInfoDetails;
}


export const LevelsInfo : React.FC<LevelsInfoProps> = ({data}) => {

    return (
        <div className="card-content">
            <h2>Nível atual:</h2>
            <h3>Compras no APP</h3>
            <ol>
                <li>
                    diário:
                    <span>{brlFormatter.format(Number(data?.transfer?.day))}</span>
                </li>
                <li>
                    mensal:
                    <span>{brlFormatter.format(Number(data?.transfer?.month))}</span>
                </li>
            </ol>
            <h3>Cartão de crédito</h3>
            <ol>
                <li>
                    diário:
                    <span>{brlFormatter.format(Number(data?.card?.day))}</span>
                </li>
                <li>
                    mensal:
                    <span>{brlFormatter.format(Number(data?.card?.month))}</span>
                </li>
            </ol>
            <h3>P2P transferências</h3>
            <ol>
                <li>
                    diário:
                    <span>{brlFormatter.format(Number(data?.p2p?.day))}</span>
                </li>
                <li>
                    mensal:
                    <span>{brlFormatter.format(Number(data?.p2p?.month))}</span>
                </li>
            </ol>
        </div>
    )
}